import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatCheckboxChange, MatChipInputEvent, MatDialog} from '@angular/material';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ConfService} from '../../conf.service';
import {DatabaseManagerComponent} from '../database-manager/database-manager.component';
import {EnvironmentCreationComponent} from './environment-creation/environment-creation.component';
import {EmailtemplateService} from '../../emailtemplate.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {SignupComponent} from '../../signup/signup.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {Loggedin} from '../../authFilter/platformCentralAuth';
import {KongService} from '../../kong.service';
import {environment} from '../../../environments/environment';
import {SignupProgressDataService} from '../../signup/signup-progress/signup-progress-data.service';
import {AuthService} from '../../user/auth.service';
import {PlatformAesService} from '../../user/platform-aes.service';
import {AuthedApiService} from '../../authed-api.service';
import {Router} from '@angular/router';
declare let $;

@Component({
  selector: 'app-environment-manager',
  templateUrl: './environment-manager.component.html',
  styleUrls: ['./environment-manager.component.scss']
})
export class EnvironmentManagerComponent implements OnInit {

  @Input() environmentPayloadInput: any;
  @Input() partner: any;
  @Input() adminEnvironmentName: any;
  @Input() displayFlag = true;
  @Input() isSignUp = true;
  @Input() environmentSummary: any;
  @Input() defaultEnvironmentObject: any;
  @Input() isDevFromAdmin = false;
  @Output() dataRetrievedToCreateInfra = new EventEmitter<{}>();
  @ViewChildren('checkboxes') checkboxes: QueryList<ElementRef>;

  isDuringOnboarding = false;
  envCreatorDnsValidationPayload: any;
  temp = [];
  temp1 = [];
  selectable = true;
  removable = true;
  removableOnNonSignup = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  password = '';
  confirmPassword = '';
  hide = true;
  confirmHide = true;

  availableEnvironments = [];
  availableEnvironmentsToDiff = [];
  nonConfiguredEnvironments = [];
  nonConfiguredEnvironmentsToShow = [];
  selectedEnvironmentsDuringSignup = [];

  customEnvironmentsOnNonSignUp = [];

  ciSelected: any;

  environments = [
    {
      environment: 'Development',
      image: './assets/img/partnerOnboarding/development.jpg',
      description: 'Development Environment',
      value: 'dev'
    },
    {
      environment: 'QA',
      image: './assets/img/partnerOnboarding/QA.png',
      description: 'QA Environment',
      value: 'qa'
    },
    {
      environment: 'Staging',
      image: './assets/img/partnerOnboarding/staging.jpg',
      description: 'Staging Environment',
      value: 'staging'
    },
    {
      environment: 'Production',
      image: './assets/img/partnerOnboarding/production.jpg',
      description: 'Production Environment',
      value: 'prod'
    }
  ];

  devEnvFromAdminID: string;
  envPkeys = {};
  item = {};
  tempSettingsPayload: any;
  isEnvironmentsCreationComplete = false;
  environmentCreationStart: boolean;
  patchAdminPartnerSettingsRetries = 0;
  isDirectNavigationWithoutDNSValidation = true;
  tempStatusVerification = 'created';
  tempStatusEnvCreation = false;
  configurationsPayload: any;
  selectedTab = 0;
  htmlContent = '';
  environmentPayload = [];

  apiKeys: any;
  apiKeyData: any;
  apiKey: any;

  rolePayload = {
    role: '',
    permission_groups: [],
    permissions: [],
    roles: [],
    exclusions: [],
    partner: '',
    account: '',
    description: '',
    type: 'account'
  };

  createdRoleId: any;

  constructor(private confPost: ConfService,
              private router: Router,
              private apiService: AuthedApiService,
              private signupDataService: SignupProgressDataService,
              private emailTemplateInstance: EmailtemplateService,
              private _service: ConnecttocrudService,
              public platform: LeftpanelComponent,
              private authService: AuthService,
              private encryptionDecryptionService: PlatformAesService,
              private auth: Loggedin,
              public dialog: MatDialog,
              private kong: KongService) { }

  ngOnInit() {
    this.setUpInitialEnvironmentsToShow();
  }

  setUpInitialEnvironmentsToShow() {
    this.availableEnvironments = [];
    this.availableEnvironmentsToDiff = [];
    this.nonConfiguredEnvironments = [];
    this.nonConfiguredEnvironmentsToShow = [];
    this.selectedEnvironmentsDuringSignup = [];
    this.environmentPayload = [
      {
        environments: [],
        custom_environments: []
      }
    ];
    for (const env of this.environmentPayloadInput) {
      this.environmentPayload[0].environments.push(env['type']);
    }
    if (this.displayFlag === false) {
      this.removable = false;
    }

    for (let i = 0; i < this.environmentPayload[0].environments.length; i++) {
      for (let j = 0; j < this.environments.length; j++) {
        if (this.environmentPayload[0].environments[i] === this.environments[j]['value']) {
          const id = 'selectedEnvironment' + j;
          if (this.isSignUp) {
            if (this.environmentPayload[0].environments[i] !== 'prod' && this.environmentPayload[0].environments[i] !== 'admin') {
              this.selectedEnvironmentsDuringSignup.push(id);
            } else {
              this.availableEnvironments.push(id);
            }
          } else {
            this.availableEnvironments.push(id);
          }
          this.availableEnvironmentsToDiff.push(this.environments[j]['value']);
        }
      }
    }

    if (this.isSignUp === false) {
      const temp1 = [];
      for (let i = 0; i < this.environments.length; i++) {
        temp1.push(this.environments[i]['value']);
      }
      const temp2 = this.arr_diff(temp1, this.availableEnvironmentsToDiff);
      let counter = 0;
      for (let i = 0; i < temp2.length; i++) {
        for (let j = 0; j < this.environments.length; j++) {
          if (temp2[i] === this.environments[j]['value']) {
            const id = 'selectedEnvironment' + counter;
            const temp = {
              id: id,
              environment: this.environments[j]['environment'],
              image: this.environments[j]['image'],
              value: this.environments[j]['value'],
              checked: false
            };
            if (this.environments[j]['value'] === 'dev') {
              temp['isFree'] = true;
            }
            this.nonConfiguredEnvironmentsToShow.push(temp);
            counter += 1;
          }
        }
      }
      for (let i = 0; i < this.nonConfiguredEnvironments.length; i++) {
        const id = 'selectedEnvironment' + i;
        const temp = {
          id: id,
          environment: this.nonConfiguredEnvironments[i]['environment'],
          image: this.nonConfiguredEnvironments[i]['image'],
          value: this.nonConfiguredEnvironments[i]['value'],
        };
        if (this.nonConfiguredEnvironments[i]['value'] === 'dev') {
          temp['isFree'] = true;
        }
        this.availableEnvironments.push(temp);
      }

    }

    if (this.isDevFromAdmin === true) {
      for (let i = 0; i < this.nonConfiguredEnvironmentsToShow.length; i++) {
        if (this.nonConfiguredEnvironmentsToShow[i]['value'] === 'dev') {
          this.nonConfiguredEnvironmentsToShow[i]['checked'] = true;
          this.devEnvFromAdminID = 'selectedEnvironmentOnNonSignUp' + i;
          // this.checkboxes[i].nativeElement.checked = true;
          this.environmentPayload[0].environments.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
          this.temp.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
          this.temp1.push(this.nonConfiguredEnvironmentsToShow[i]);
        }
      }
    }

    const that = this;
    $(document).ready(function () {
      $('#superAdmin').addClass('selectedEnvironment1');
      for (const id of that.availableEnvironments) {
        // $('#' + id).addClass('selectedEnvironment1');
      }
      for (const id of that.selectedEnvironmentsDuringSignup) {
        $('#' + id).addClass('selectedEnvironment');
      }
    });
  }
  arr_diff (a1, a2) {

    const a = [], diff = [];

    for (let i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }

    for (let i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }

    for (const k in a) {
      diff.push(k);
    }

    return diff;
  }

  toggleCustomEnvironment(event: MatCheckboxChange) {
    if (event.checked) {
      $('#customEnvironmentForm').css('display', 'block');
      // this.environmentPayload[0].is_custom = true;
    } else {
      $('#customEnvironmentForm').css('display', 'none');
      // this.environmentPayload[0].custom_environments = [];
      // this.environmentPayload[0].is_custom = false;
    }
  }

  checkSelectEnvironment(index, event: MatCheckboxChange) {
    if (event.checked) {
      for (let i = 0; i < this.nonConfiguredEnvironmentsToShow.length; i++) {
        const id = 'selectedEnvironmentOnNonSignUp' + i;
        if (index === i) {
          let isAlreadyPresent = false;
          for (const env of this.temp) {
            if (env === this.nonConfiguredEnvironmentsToShow[i]['value']) {
              isAlreadyPresent = true;
            }
          }
          if (isAlreadyPresent === false) {
            this.environmentPayload[0].environments.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
            this.temp.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
            this.temp1.push(this.nonConfiguredEnvironmentsToShow[i]);
            this.selectedTab = this.temp.length - 1;
          } else {
            this.nonConfiguredEnvironmentsToShow[i]['checked'] = false;
            alert('Environment with name ' + this.nonConfiguredEnvironmentsToShow[i]['value'] + ' is already been used');
            event.source.checked = false;
          }
        }
      }
    } else {
      for (let i = 0; i < this.nonConfiguredEnvironmentsToShow.length; i++) {
        const id = 'selectedEnvironmentOnNonSignUp' + i;
        if (index === i) {
          for (let j = 0; j < this.environmentPayload[0].environments.length; j++) {
            if (this.nonConfiguredEnvironmentsToShow[i]['value'] === this.environmentPayload[0].environments[j]) {
              this.environmentPayload[0].environments.splice(j, 1);
              const key = this.nonConfiguredEnvironmentsToShow[i]['value'];
              delete this.platform.configurationsForEnvCreation[key];
              this.temp.splice(this.temp.indexOf(this.nonConfiguredEnvironmentsToShow[i]['value']), 1);
              const tempArray = [];
              for (const object of this.temp1) {
                if (object['value'] !== this.nonConfiguredEnvironmentsToShow[i]['value']) {
                  tempArray.push(object);
                }
              }
              this.temp1 = tempArray;
            }
          }
        }
      }
    }
  }

  selectEnvironment(index) {
    if (this.isSignUp) {
      const id1 = 'selectedEnvironment' + index;
      if ($('#' + id1).hasClass('selectedEnvironment1')) {
      } else {
        for (let i = 0; i < this.environments.length; i++) {
          const id = 'selectedEnvironment' + i;
          if (index === i) {
            if ($('#' + id).hasClass('selectedEnvironment')) {
              $('#' + id).removeClass('selectedEnvironment');
              for (let j = 0; j < this.environmentPayload[0].environments.length; j++) {
                if (this.environments[i]['value'] === this.environmentPayload[0].environments[j]) {
                  this.environmentPayload[0].environments.splice(j, 1);
                  this.temp.splice(this.temp.indexOf(this.environments[i]['value']), 1);
                }
              }
              if (this.defaultEnvironmentObject && this.environmentSummary) {
                for (let j = 0; j < this.environmentSummary.length; j++) {
                  if (this.environments[i]['value'] === this.environmentSummary[j]['type']) {
                    this.environmentSummary.splice(j, 1);
                  }
                }
              }
            } else {
              $('#' + id).addClass('selectedEnvironment');
              this.environmentPayload[0].environments.push(this.environments[i]['value']);
              this.temp.push(this.environments[i]['value']);
              if (this.defaultEnvironmentObject && this.environmentSummary) {
                const tempObject = JSON.parse(JSON.stringify(this.defaultEnvironmentObject));
                tempObject['type'] = this.environments[i]['value'];
                this.environmentSummary.push(tempObject);
              }
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.nonConfiguredEnvironmentsToShow.length; i++) {
        const id = 'selectedEnvironmentOnNonSignUp' + i;
        if (index === i) {
          if ($('#' + id).hasClass('selectedEnvironment')) {
            $('#' + id).removeClass('selectedEnvironment');
            for (let j = 0; j < this.environmentPayload[0].environments.length; j++) {
              if (this.nonConfiguredEnvironmentsToShow[i]['value'] === this.environmentPayload[0].environments[j]) {
                this.environmentPayload[0].environments.splice(j, 1);
                const key = this.nonConfiguredEnvironmentsToShow[i]['value'];
                delete this.platform.configurationsForEnvCreation[key];
                this.temp.splice(this.temp.indexOf(this.nonConfiguredEnvironmentsToShow[i]['value']), 1);
                const tempArray = [];
                for (const object of this.temp1) {
                  if (object['value'] !== this.nonConfiguredEnvironmentsToShow[i]['value']) {
                    tempArray.push(object);
                  }
                }
                this.temp1 = tempArray;
              }
            }
          } else {
            let isAlreadyPresent = false;
            for (const env of this.temp) {
              if (env === this.nonConfiguredEnvironmentsToShow[i]['value']) {
                isAlreadyPresent = true;
              }
            }
            if (isAlreadyPresent === false) {
              $('#' + id).addClass('selectedEnvironment');
              this.environmentPayload[0].environments.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
              this.temp.push(this.nonConfiguredEnvironmentsToShow[i]['value']);
              this.temp1.push(this.nonConfiguredEnvironmentsToShow[i]);
              this.selectedTab = this.temp.length - 1;
            } else {
              alert('Environment with name ' + this.nonConfiguredEnvironmentsToShow[i]['value'] + ' is already been used');
            }
          }
        }
      }
    }
  }

  getApiKeyForUser(signInEmail) {
    return new Promise((resolve, reject) => {
      this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
        this.apiKeyData = keys;
        if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
          this.apiKeys = this.apiKeyData.data;
          this.apiKey = this.apiKeys[0].key;
          localStorage.setItem('apikey', this.apiKey);
          resolve('success');
        } else {
          resolve('success');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  setLocalStorage(environment, signInEmail) {
    localStorage.setItem('Auth', 'true');
    localStorage.setItem('partner', this.configurationsPayload[environment]['partnerPayload']['partner']);
    localStorage.setItem('partnerKey', this.configurationsPayload[environment]['partnerPayload']['partnerKey']);
    localStorage.setItem('currentPlan', this.configurationsPayload[environment]['partnerPayload']['currentPlan']);
    localStorage.setItem('account', this.configurationsPayload[environment]['partnerPayload']['accounts'][0]['account_id']);
    localStorage.setItem('signInEmail', signInEmail);
  }

  navigateToDashboardDirectly(envParam) {
    const temp = localStorage.getItem('partner').split('-');
    if (temp.length > 1) {
      this.partner = temp[temp.length - 1];
    } else {
      this.partner = localStorage.getItem('partner');
    }
    let partner = '';
    if (envParam !== 'prod') {
      partner = envParam + '-' + this.partner;
    } else {
      partner = this.partner;
    }
    const signInEmail = localStorage.getItem('signInEmail');
    // this.auth.clearLocalStorage();

    for (const environment1 of this.configurationsPayload[envParam]['environmentResponseArray']) {
      // environment1['isValidationComplete'] = true;
      if (environment1['type'] === envParam) {
        for (const URLObject of environment1['URLs']) {
          if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
            Promise.resolve(this.authService.generateAuthenticatorToken(partner,
                this.encryptionDecryptionService.decrypt(this.configurationsPayload[envParam]['partnerPayload']['shash'],
                    this.configurationsPayload[envParam]['partnerPayload']['ralam'],
                    this.configurationsPayload[envParam]['partnerPayload']['account_password']),
                signInEmail)).then(response => {
              let tokenObj: any;
              tokenObj = response;
              this.validateDNS1(URLObject, 3, 10000).then(response1 => {
                if (this.tempStatusVerification === 'verified') {
                  URLObject['isVerified'] = this.tempStatusVerification;
                } else {
                  URLObject['isVerified'] = 'not verified';
                }
              }, error => {

              });
              Promise.resolve(this.platform.validateDNS([tokenObj.partner + '.apiplatform.io'])).then(resp1 => {
                const verified = (resp1 === 'verified');
                this.authService.redirectWithAuthenticatorToken(verified, tokenObj.partner, tokenObj.token);
              }, error => {
                this.authService.redirectWithAuthenticatorToken(false, tokenObj.partner, tokenObj.token);
              });
            }, error => {
              // window.location.href = environment.platformRedirectURL + '/auth/login';
              this.platform.openSnackBar(error, 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          }
        }
      }
    }
  }

  redirectToConsole(data, URLObject, loginPayload, isVerified) {
    if (data && data.hasOwnProperty('body') && data['body'][0] && data['body'][0]['partner'] && data['body'][0]['partnerKey'] &&
        data['body'][0].hasOwnProperty('accounts') && data.body[0].accounts[0] && data.body[0].accounts[0].hasOwnProperty('account_id')) {
      this.confPost.createJWTToken(data.body[0].partner, data.body[0].accounts[0].account_id !== undefined ? data.body[0].accounts[0].account_id : data.body[0].partner, data.body[0].partnerKey, {claims: loginPayload, consumedBy: 'apiplatform'}).subscribe(response2 => {
        if (response2 && response2['body']) {
          let redirectURL = '';
          const account = data.body[0].accounts[0].account_id !== undefined ? data.body[0].accounts[0].account_id : data.body[0].partner;
          if (isVerified) {
            if (environment.isOnPremise === false) {
              redirectURL = 'https://' + URLObject['url'] + '/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
            } else {
              redirectURL = environment.platformRedirectURL + '/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
            }
          } else {
            redirectURL = environment.platformRedirectURL + '/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
          }
          window.location.href = redirectURL;
        }
      }, error => {
        window.location.href = environment.platformRedirectURL + '/auth/login';
      });
    } else {
      this.platform.openSnackBar('Error while navigating to environment. Please login again.', 'Error', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      window.location.href = environment.platformRedirectURL + '/auth/login';
    }
  }

  patchPartnerSettings(tempPayload, response) {
    return new Promise((resolve, reject) => {
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response[0]['id'], tempPayload).subscribe(response3 => {
        this.isEnvironmentsCreationComplete = true;
        resolve('success');
      }, error1 => {
        this.patchAdminPartnerSettingsRetries += 1;
        if (this.patchAdminPartnerSettingsRetries <= 3) {
          setTimeout(() => {
            this.patchAdminPartnerSettings(tempPayload, response).then(response1 => {
              resolve(response1);
            });
          }, 500);
        } else {
          this.isEnvironmentsCreationComplete = true;
          resolve('failure');
        }
      });
    });
  }

  patchAdminPartnerSettings(tempPayload, response) {
    return new Promise((resolve, reject) => {
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response[0]['id'], tempPayload).subscribe(response3 => {
        this.isEnvironmentsCreationComplete = true;
        resolve('success');
      }, error1 => {
        this.patchAdminPartnerSettingsRetries += 1;
        if (this.patchAdminPartnerSettingsRetries <= 3) {
          setTimeout(() => {
            this.patchAdminPartnerSettings(tempPayload, response).then(response1 => {
              resolve(response1);
            });
          }, 500);
        } else {
          this.isEnvironmentsCreationComplete = true;
          resolve('failure');
        }
      });
    });
  }

  recreateEnvironment(URLObject, payload, maxTries, duration) {
    return new Promise(async (resolve, reject) => {
      await setTimeout(() => {
        this.confPost.createEnvironment(payload).subscribe(response => {
          if (response) {
            const responseFromApi = response;
            this.tempStatusEnvCreation = responseFromApi['body']['URLs'][0]['status'];
            if (this.tempStatusEnvCreation === true) {
              URLObject['url'] = responseFromApi['body']['URLs'][0]['url'];
            }
            resolve(this.tempStatusEnvCreation);
          }
        }, error => {
          this.recreateEnvironment(URLObject, payload, maxTries, duration).then(response1 => {
            resolve(response1);
          });
        });
      }, duration);
    });
  }

  async recreateEnvironmentURLObject(URLObject, payload, maxTries, duration) {
    for (let i = 0; i < maxTries; i++) {
      if (!this.tempStatusEnvCreation) {
        await this.recreateEnvironment(URLObject, payload, maxTries, duration).then(response => {
          if (this.tempStatusEnvCreation) {
            return response;
          }
        });
      }
    }
    // this.tempStatusVerification = 'not verified';
    return this.tempStatusEnvCreation;
  }

  async validateEachEnvironmentCreation(event, environment) {
    return new Promise(async (resolve, reject) => {
      const env = environment;
      for (const environment of event[env]['environmentResponseArray']) {
        for (const URLObject of environment['URLs']) {
          URLObject['isVerified'] = 'created';
          URLObject['envCreationStatus'] = 'started';
          if (URLObject['status'] === false) {
            const payloadToResend = {
              partner: '',
              account: '',
              configuration: {
                devex: [''],
                dashboard: [''],
                apigateway: [''],
                storage: ['']
              }
            };
            // if (environment['type'] === 'prod') {
            //   payloadToResend.partner = this.item['partner'];
            //   payloadToResend.account = this.item['partner'];
            // } else {
            //   payloadToResend.partner = environment['type'] + '-' + this.item['partner'];
            //   payloadToResend.account = environment['type'] + '-' + this.item['partner'];
            // }
            payloadToResend.partner = event[env]['partnerPayload']['partner'];
            payloadToResend.account = event[env]['partnerPayload']['accounts'][0]['account_id'];
            payloadToResend['configuration'][URLObject['type']] = [this.ciSelected];
            await this.recreateEnvironmentURLObject(URLObject, payloadToResend, 3, 5000).then(response => {
              if (this.tempStatusEnvCreation) {
                URLObject['status'] = this.tempStatusEnvCreation;
                URLObject['envCreationStatus'] = 'success';
              } else {
                URLObject['status'] = false;
                URLObject['envCreationStatus'] = 'failed';
              }
            });
          } else {
            URLObject['envCreationStatus'] = 'success';
          }
        }
        environment['isCreationComplete'] = true;
      }
      resolve(event[env]['environmentResponseArray']);
      // }
    });
  }

  resolveDNSValidation(payload, maxTries, duration) {
    return new Promise(async (resolve, reject) => {
      await setTimeout(() => {
        this.confPost.dnsValidation({domainName: [payload['url']]}).subscribe(response => {
          if (response) {
            const responseFromApi = response;
            if (responseFromApi['body']['response'][0]['status']) {
              this.tempStatusVerification = 'verified';
            }
            resolve(this.tempStatusVerification);
          }
        }, error => {
          this.resolveDNSValidation(payload, maxTries, duration).then(response1 => {
            if (response1) {
              // const responseFromApi = response1;
              // if (responseFromApi['body']['response'][0]['status']) {
              //     this.tempStatusVerification = 'verified';
              //     resolve(this.tempStatusVerification);
              // }
              this.tempStatusVerification = JSON.stringify(response1);
              resolve(this.tempStatusVerification);
            }
          });
        });
      }, duration);
    });
  }

  async validateDNS1(payload, maxTries, duration) {
    for (let i = 0; i < maxTries; i++) {
      if (this.tempStatusVerification !== 'verified') {
        await this.resolveDNSValidation(payload, maxTries, duration).then(response => {
          if (this.tempStatusVerification === 'verified') {
            return;
          }
        });
      }
    }
    // this.tempStatusVerification = 'not verified';
    return this.tempStatusVerification;
  }

  async validateEachEnvironment(event, environment) {
    let i = 0;
    const env = environment;
    if (event[env]['environmentResponseArray'] && event[env]['environmentResponseArray'].length > 0) {
      for (const environment of event[env]['environmentResponseArray']) {
        environment['isEnabled'] = true;
        i += 1;
        let j = 0;
        for (const URLObject of environment['URLs']) {
          j += 1;
          this.tempStatusVerification = 'created';
          URLObject['isVerified'] = this.tempStatusVerification;
          if (URLObject['status'] === true) {
            await this.validateDNS1(URLObject, 3, 10000).then(response => {
              if (this.tempStatusVerification === 'verified') {
                URLObject['isVerified'] = this.tempStatusVerification;
              } else {
                URLObject['isVerified'] = 'not verified';
              }
            });
          }
          if (j === environment['URLs'].length) {
            environment['isValidationComplete'] = true;
          }
        }
      }
      if (i === event[env]['environmentResponseArray'].length) {
        return;
      }
    }
  }

  pushEnvironment1(partner, partnerPayload, event, payload, environment) {
    return new Promise((resolve, reject) => {
      this.confPost.createEnvironment(payload).subscribe(response => {
        const responseFromAPI = response;
        responseFromAPI['body']['isValidationComplete'] = false;
        event[environment]['environmentResponseArray'].push(responseFromAPI['body']);
        this.environmentCreationStart = true;
        // if (event[environment]['environmentResponseArray'].length === environments.length) {
        this.validateEachEnvironmentCreation(event, environment).then(response1 => {
          if (this.isDirectNavigationWithoutDNSValidation === true) {

            this.envCreatorDnsValidationPayload = event[environment]['environmentResponseArray'];
            // this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + environment + '-' + this.partner + '&account=' + environment + '-' + this.partner).subscribe(response2 => {
            this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + payload['partner'] + '&account=' + payload['account']).subscribe(response2 => {
              // const partner_settings = response2[0]['partner_settings'];
              // const envArray = response2[0]['partner_settings']['environment'][0]['environments'];
              // const envConfigArray = response2[0]['environments'];

              this.htmlContent = '';
              this.htmlContent += '<div>\n' +
                  '    <table width="100%" align="center">\n' +
                  '        <tbody>\n' +
                  '        <tr>\n' +
                  '            <td bgcolor="#F0F0F0">\n' +
                  '                <table width="90%" align="center" style="max-width: 1150px">\n' +
                  '                    <tbody>\n' +
                  '                    <tr>\n' +
                  '                        <td height="32"></td>\n' +
                  '                    </tr>\n' +
                  '                    <tr>\n' +
                  '                        <td align="left" bgcolor="#FFFFFF" style="border-radius: 2rem;">\n' +
                  '                            <div style="box-shadow: 1px 1px 20px #aaaaaa;border-radius: inherit;">\n' +
                  '                                <table width="100%" align="center">\n' +
                  '                                    <tbody>\n' +
                  '                                    <tr>\n' +
                  '                                        <td></td>\n' +
                  '                                        <td>\n' +
                  '                                            <div align="right" style="float:right;padding: 5px 20px 5px 5px;">\n' +
                  '                                               <table>\n' +
                  '                                                    <tr>\n' +
                  '                                                        <td>\n' +
                  '                                                            <span style="vertical-align: middle;display: table-cell;"><img style="height:30px;vertical-align:middle;" height="30" src="https://console.apiplatform.io/assets/logo/logo.png"></span>\n' +
                  '                                                        </td>\n' +
                  '                                                        <td>\n' +
                  '                                                            <span style="vertical-align: middle;display: table-cell;font-family: poppins,sans-serif!important;font-size: 17px;font-weight: 500;padding-left: 4px;"> apiplatform<span>.</span>io</span>\n' +
                  '                                                        </td>\n' +
                  '                                                    </tr>\n' +
                  '                                                </table>' +
                  '                                            </div>\n' +
                  '                                        </td>\n' +
                  '                                    </tr>\n' +
                  '                                    <tr>\n' +
                  '                                        <td width="200">\n' +
                  '                                            <span style="vertical-align: middle;display: table-cell;"><img style="height:150px;vertical-align:middle;" height="150" src="https://console.apiplatform.io/assets/cover/create-banner-img.jpg"></span>\n' +
                  '                                        </td>\n' +
                  '                                        <td width="100%" style="padding-right: 20px; min-width: 550px; padding-left: 30px" >\n' +
                  '                                            <div align="left" style="font-family: poppins,sans-serif!important;word-break: break-word;" >\n' +
                  '\n' +
                  '\n' +
                  '                                                <p>\n' +
                  '                                                    Thank you for choosing apiplatform<span>.</span>io - the future of API Development. We are excited to have you onboard with us.\n' +
                  '                                                </p>\n' +
                  '                                                <p>apiplatform<span>.</span>io offers an end-to-end engineering, integration and management platform for APIs -  consisting the right blend of capabilities and intelligence to develop and deliver your applications instantly. You do not need to look for multiple tools and services installed and configured in silos, as apiplatform<span>.</span>io enables you to get started with your development right away.\n' +
                  '                                                </p>\n' +
                  '                                                <p>\n' +
                  '                                                    We are happy to share the environments created successfully to administer and develop your applications as listed below.\n' +
                  '                                                </p>\n' +
                  '                                                <br>';

              for (const environment1 of event[environment]['environmentResponseArray']) {

                this.htmlContent += '<table width="100%" style="border: 1px solid black;max-width: 700px;">\n' +
                    '    <tbody style="background-color: rgb(240,235,235);">\n' +
                    '    <tr align="center" style="background-color: black">\n' +
                    '        <th colspan="2" style="color: white">Environment : ' + environment1['type'] + '-' + this.partner + '</th>\n' +
                    '    </tr>\n' +
                    '    <tr align="left">\n' +
                    '        <th width="30%">Tools and Services</th>\n' +
                    '        <th>URL</th>\n' +
                    '    </tr>';


                for (const URLObject of environment1['URLs']) {

                  this.htmlContent += '<tr>\n' +
                      '        <td>' + URLObject['type'] + '</td>\n' +
                      '        <td><a href=' + URLObject['url'] + '>' + URLObject['url'] + '</a></td>\n' +
                      '    </tr>';


                }
                this.htmlContent += '</tbody>'
                    + '</table><br>';
              }

              this.htmlContent += '<p>We are eager to see you use apiplatform.io that takes you from IDEA to PRODUCT <span style="color: orange;">in half the time, at half the cost.</span> Please feel free to reply to this email if you need any help. </p><br>\n' +
                  '\n' +
                  '                                                <p>\n' +
                  '                                                    Your apiplatform<span>.</span>io team\n' +
                  '                                                </p>\n' +
                  '                                                <p>\n' +
                  '                                                    <a href="mailto:experience@apiplatform.io">experience@apiplatform.io</a>\n' +
                  '                                                </p>';

              this.htmlContent += '</div>\n' +
                  '                                        </td>\n' +
                  '                                    </tr>\n' +
                  '                                    <tr>\n' +
                  '                                        <td height="22" colspan="3"></td>\n' +
                  '                                    </tr>\n' +
                  '                                    </tbody>\n' +
                  '                                </table>\n' +
                  '                            </div>\n' +
                  '                        </td>\n' +
                  '                    </tr>\n' +
                  '                    <tr>\n' +
                  '                        <td height="32"></td>\n' +
                  '                    </tr>\n' +
                  '\n' +
                  '                    </tbody>\n' +
                  '                </table>\n' +
                  '            </td>\n' +
                  '        </tr>\n' +
                  '        </tbody>\n' +
                  '    </table>\n' +
                  '</div>';


              for (const env of event[environment]['environmentResponseArray']) {
                // envArray.push(env['type']);
                // envConfigArray.push(env);
                if (env['type'] === environment) {
                  for (const URLObject of env['URLs']) {
                    const servicePayload = {
                      configurations: []
                    };
                    const serviceConfig = {
                      regions: []
                    };
                    switch (URLObject['type']) {
                      case 'dashboard':
                        servicePayload['name'] = 'Platform Console';
                        serviceConfig['name'] = 'Platform Console';
                        break;
                      case 'devex':
                        servicePayload['name'] = 'Developer Experience';
                        serviceConfig['name'] = 'Developer Experience';
                        break;
                      case 'apigateway':
                        servicePayload['name'] = 'API Gateway Manager';
                        serviceConfig['name'] = event[environment]['selectedAPIGateway']['name'];
                        serviceConfig['type'] = event[environment]['selectedAPIGateway']['type'];
                        serviceConfig['provider'] = event[environment]['selectedAPIGateway']['provider'];
                        serviceConfig['gateway_configurations'] = event[environment]['selectedAPIGateway']['gateway_configurations'];
                        serviceConfig['config'] = event[environment]['selectedAPIGateway']['config'];
                        break;
                      case 'storage':
                        servicePayload['name'] = 'Storage';
                        serviceConfig['name'] = 'Storage';
                        serviceConfig['provider'] = 'apiplatform.io';
                        break;
                      default:
                        servicePayload['name'] = '';
                        serviceConfig['name'] = '';
                        break;
                    }
                    servicePayload['type'] = URLObject['type'];
                    if (URLObject['type'] === 'apigateway') {
                      if (this.isDuringOnboarding) {
                        serviceConfig['url'] = URLObject['url'];
                      } else {
                        serviceConfig['url'] = [URLObject['url']];
                      }
                    } else {
                      serviceConfig['url'] = URLObject['url'];
                    }
                    serviceConfig['audit_logs'] = [{
                      action: 'CREATE',
                      by: localStorage.getItem('signInEmail'),
                      at: Date.now()
                    }];
                    serviceConfig['status'] = URLObject['status'];
                    serviceConfig['verification_status'] = URLObject['isVerified'];
                    serviceConfig['env_creation_status_after_verification'] = URLObject['envCreationStatus'];
                    serviceConfig['is_default'] = true;
                    serviceConfig['cloud'] = event[environment]['settingsPayload']['environments'][0]['cloud'][0]['type'];
                    serviceConfig['primary_region'] = event[environment]['settingsPayload']['environments'][0]['cloud'][0]['region'];
                    serviceConfig['regions'][0] = event[environment]['settingsPayload']['environments'][0]['cloud'][0]['region'];
                    servicePayload.configurations.push(serviceConfig);
                    response2[0]['environments'][0]['services'].push(servicePayload);
                  }
                }
              }

              this.emailTemplateInstance.environmentURLs.to.value[0].email = partnerPayload['primary_email'];
              this.emailTemplateInstance.environmentURLs.body.value = this.htmlContent;
              this.confPost.executeEmail(this.emailTemplateInstance.environmentURLs).subscribe(res => {});

              // partner_settings['environment'][0]['environments'] = envArray;
              // const tempPayload = {
              //   environments: envConfigArray,
              //   partner_settings: partner_settings
              // };
              // this.patchPayload = tempPayload;
              this.patchAdminPartnerSettings(response2[0], response2).then(response3 => {
                resolve('success');
              });
            });
          } else {
            this.validateEachEnvironment(event, environment).then(response => {
              // let i = 0;
              // for (const env of event[environment]['environmentResponseArray']) {
              //     i += 1;
              // if (i === event[environment]['environmentResponseArray'].length) {
              let isAdminPresent = false;
              for (const environment1 of event[environment]['environmentResponseArray']) {
                environment1['isValidationComplete'] = true;
                if (environment1['type'] === 'admin') {
                  isAdminPresent = true;
                  for (const URLObject of environment1['URLs']) {
                    if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
                      this.validateDNS1(URLObject, 3, 10000).then(response => {
                        if (this.tempStatusVerification === 'verified') {
                          URLObject['isVerified'] = this.tempStatusVerification;
                        } else {
                          URLObject['isVerified'] = 'not verified';
                        }
                        this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                          const tempPayload = {
                            environments: event[environment]['environmentResponseArray'],
                          };
                          this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
                            resolve('success');
                          });
                        });
                      });
                    } else {
                      this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                        const tempPayload = {
                          environments: event[environment]['environmentResponseArray'],
                        };
                        // this.patchPayload = tempPayload;
                        this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
                          resolve('success');
                        });
                      });
                    }
                  }
                }
              }
              if (!isAdminPresent) {
                this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                  for (const env of event[environment]['environmentResponseArray']) {
                    response2[0]['environments'].push(env);
                  }
                  this.patchAdminPartnerSettings(response2[0], response2).then(response3 => {
                    resolve('success');
                  });
                  // this.confPost.patchEntity('services', 'services', response2[0], 'settings', response2[0]['id']).subscribe(response3 => {
                  //     this.isEnvironmentsCreationComplete = true;
                  // });
                });
              }
              // }
              // }
            });
          }
        });
        // } else {
        //   resolve('success');
        // }
      }, error => {
        this.pushEnvironment1(partner, partnerPayload, event, payload, environment).then(response => {
          resolve(response);
        });
      });
    });
  }

  createAccountRole(partnerPayload) {
    this.rolePayload.partner = partnerPayload['partner'];
    this.rolePayload.account = partnerPayload['partner'];
    this.rolePayload.role = partnerPayload['partner'] + '=>' + partnerPayload['partner'] + '=>' + partnerPayload['primary_email'];
    return new Promise((resolve, reject) => {
      this._service.addItem(this.rolePayload, 'v1', 'access', 'access', 'roles').subscribe(async resp => {
        if (resp && resp.hasOwnProperty('upsertedId')) {
          this.createdRoleId = resp['upsertedId'];
        }
        resolve('success');
      }, async error1 => {
        resolve('failed');
      });
    });
  }

  patchAdminUser(settingsPayload, partnerPayload) {
    return new Promise((resolve, reject) => {
      const temp = settingsPayload['partner'].split('-');
      this.confPost.getData('access', 'access', 'v1', 'users', 'user=admin-' + temp[temp.length - 1]).subscribe(resp => {
        let userResponse: any;
        userResponse = resp;
        if (userResponse && userResponse.length > 0) {
          const userEnvironments = userResponse[0]['environments'];
          const envObject = {
            name: settingsPayload['partner'],
            account: settingsPayload['partner'],
            roles: [2],
            password: partnerPayload['account_password'],
            shash: partnerPayload['shash'],
            ralam: partnerPayload['ralam'],
            exclusions: {
              permissions: [],
              permission_groups: [],
              roles: []
            },
            audit_logs: [
              {
                action: 'CREATE',
                by: partnerPayload['primary_email'],
                at: Date.now()
              }
            ]
          };
          if (this.createdRoleId) {
            envObject.roles.push(this.createdRoleId);
          }
          userEnvironments.push(envObject);
          this.confPost.patchEntityData('access', 'access', 'v1', 'users', userResponse[0]['id'], {environments: userEnvironments}).subscribe(response => {
            resolve('success');
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('failed');
        }
      });
    });
  }

  async createInfraWithAccount(event, partner, environmentType, partnerPayload, settingsPayload, environmentPayload) {
    return new Promise(async (resolve, reject) => {
      let partnerCreated: boolean;
      await this.confPost.insertPartner(partnerPayload).subscribe(async data => {
        this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Creating Development environment'});

        this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].partner = partner;
        // this.confPost.executeEmail(this.emailTemplateInstance.notifyPartnerOnboarding).subscribe(response => {});

        // this.tempSettingsPayload = settingsPayload;
        // // if (environment === 'admin') {
        // //   localStorage.setItem('partnerId', data['id']);
        // // } else {
        //   this.tempSettingsPayload.partner_settings.environment[0].environments = [];
        // // }
        // settingsPayload.partner_settings.environment[0].environments = [];

        await this.createAccountRole(partnerPayload);

        await this.patchAdminUser(settingsPayload, partnerPayload);

        await this._service.addItem(settingsPayload, 'v2', 'services', 'services', 'settings').subscribe(
            data1 => {
              this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up development environment console'});
              this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up development environment devex'});
              this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Creating gateway for development environment'});
              this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Creating S3 bucket for development environment'});
              this.pushEnvironment1(partner, partnerPayload, event, environmentPayload, environmentType).then(async response1 => {
                await this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + environmentPayload['partner'] + '&account=' + environmentPayload['account']).subscribe(response2 => {
                  const s3BucketConnectors = [];
                  for (const env of event[environmentType]['environmentResponseArray']) {
                    if (env['type'] === environmentType) {
                      // const s3Payload = {};
                      const servicePayload = {
                        configurations: []
                      };
                      for (const URLObject1 of env['URLs']) {
                        if (URLObject1['type'] === 'storage') {
                          const temp = URLObject1['url'].split('/');
                          // s3Payload['bucketName'] = temp[temp.length - 1];
                          // s3Payload['defaultBucket'] = true;
                          const serviceConfig = {};
                          servicePayload['name'] = 'S3 Bucket Connectors';
                          servicePayload['type'] = 's3BucketConnectors';
                          serviceConfig['name'] = 'S3 Bucket Connectors';
                          serviceConfig['audit_logs'] = [{
                            action: 'CREATE',
                            by: localStorage.getItem('signInEmail'),
                            at: Date.now()
                          }];
                          serviceConfig['is_default'] = true;
                          serviceConfig['provider'] = 'apiplatform.io';
                          serviceConfig['bucketName'] = temp[temp.length - 1];
                          serviceConfig['defaultBucket'] = true;

                          servicePayload.configurations.push(serviceConfig);
                          response2[0]['environments'][0]['services'].push(servicePayload);
                        }
                      }
                      // s3BucketConnectors.push(s3Payload);
                    }
                  }
                  // response2[0]['configurations']['s3BucketConnectors'] = s3BucketConnectors;
                  Promise.resolve(this.patchAdminPartnerSettings(response2[0], response2)).then(response3 => {
                    partnerCreated = true;
                    this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + environmentPayload['partner'] + '&account=' + environmentPayload['account']).subscribe(resp => {
                      this.confPost.getSettingsV2CRUD('admin-' + this.partner, 'admin-' + this.partner, false).subscribe(response2 => {
                        const responseFromAPI = response2['body'][0];
                        if (this.platform.isAdminForPartner === false) {
                          responseFromAPI['environments'].push(resp[0]['environments'][0]);
                        }
                        this.patchAdminPartnerSettings(responseFromAPI, response2['body']).then(response3 => {
                          const platformServices = new Promise((resolve, reject) => {
                            this.confPost.getData('services', 'services', 'v1', 'platformServices', '').subscribe(response => {
                              const iterator = response[Symbol.iterator]();
                              while (true) {
                                const tempObject = iterator.next();
                                if (tempObject.done) {
                                  break;
                                }
                                resp[0].subscriptions.platform_services.push(tempObject.value.id);
                              }
                              resolve('success');
                            }, error => {
                              resolve('failed');
                            });
                          });

                          const platformServiceCategories = new Promise((resolve, reject) => {
                            this.confPost.getData('services', 'services', 'v1', 'platformServiceCategories', '').subscribe(response => {
                              const iterator = response[Symbol.iterator]();
                              while (true) {
                                const tempObject = iterator.next();
                                if (tempObject.done) {
                                  break;
                                }
                                resp[0].subscriptions.platform_service_categories.push(tempObject.value.id);
                              }
                              resolve('success');
                            }, error => {
                              resolve('failed');
                            });
                          });

                          Promise.all([platformServices, platformServiceCategories]).then(response4 => {
                            this.patchAdminPartnerSettings(resp[0], resp).then(response5 => {
                              // await this.sleep(500);
                              this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
                                  .subscribe(updatedSettings => {
                                    this.platform.settingsData = updatedSettings;
                                  });
                              resolve(partnerCreated);
                            });
                          });
                        });
                      });
                    });
                  });
                });
                this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up development environment console'});
                this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up development environment devex'});
                this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Creating gateway for development environment'});
                this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Creating S3 bucket for development environment'});

              });
            }
        );
      }, error1 => {
        // const engagementObject = {
        //   partnerOnboardingStatus: false,
        //   adminEmailPayload: this.emailTemplateInstance.notifyAdmins,
        //   message: 'Partner ' + this.partner + ' with email ' + this.email + ' creation has failed. ' + error1.error.message ? error1.error.message : error1.error
        // };
        // this.confPost.sendEngagementMailDuringOnboarding(engagementObject).subscribe();
        if (partnerCreated === true) {
          resolve(partnerCreated);
        }
        this.platform.openSnackBar('Error while creating Partner Account or the environment has been already created. Try logging in into the ' + environmentType + ' environment as ' + environmentType + '-' + this.partner, 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    });
  }

  validateDNS(url) {
    return new Promise((resolve, reject) => {
      this.confPost.dnsValidation({domainName: url}).subscribe(response => {
        if (response) {
          const responseFromApi = response;
          if (responseFromApi['body']['response'][0]['status']) {
            resolve('verified');
          } else {
            resolve('not verified');
          }
        }
      }, async error => {
        reject('failed');
      });
    });
  }

  navigateToConsole(envConfig, index) {
    if (confirm('You will be logged out from the current environment and redirected to created environment. Do you still want to navigate?')) {

      if (envConfig) {
        let partner = '';
        if (envConfig.environment.env === 'prod') {
          partner = envConfig.partner;
        } else {
          partner = envConfig.environment.env + envConfig.partner;
        }
        this.configurationsPayload[this.temp1[index]['value']]['environmentNavigationLoading'] = true;
        Promise.resolve(this.authService.generateAuthenticatorToken(partner, envConfig.environment.password)).then(response => {

          let authTokenContainer: any;
          authTokenContainer = response;
          Promise.resolve(this.platform.validateDNS([authTokenContainer.partner + '.apiplatform.io'])).then(resp1 => {
            const verified = (resp1 === 'verified');
            this.configurationsPayload[this.temp1[index]['value']]['environmentNavigationLoading'] = false;
            this.authService.redirectWithAuthenticatorToken(verified, authTokenContainer.partner, authTokenContainer.token);
          }, error => {
            this.configurationsPayload[this.temp1[index]['value']]['environmentNavigationLoading'] = false;
            this.authService.redirectWithAuthenticatorToken(false, authTokenContainer.partner, authTokenContainer.token);
          });
        }, error => {
          this.configurationsPayload[this.temp1[index]['value']]['environmentNavigationLoading'] = false;
          this.platform.openSnackBar(error, 'Error', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    }

  }

  createEnvironmentWithAPI(payload, index) {

    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      width: 'auto',
      height: 'auto',
    });
    this.apiService.createEnvironment(payload).subscribe(response => {

      // if (this.configurationsPayload) {
      //   this.configurationsPayload = {};
      // }
      // this.configurationsPayload[this.temp1[index]['value']] = {};
      // this.configurationsPayload[this.temp1[index]['value']]['environmentConfig'] = payload;
      // this.configurationsPayload[this.temp1[index]['value']]['environmentNavigationLoading'] = false;
      // this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse'] = response;
      //
      // if (this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse']['infras']) {
      //   this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse']['URLs'] = [];
      //   for (const key of Object.keys(this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse']['infras'])) {
      //     this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse']['URLs'].push({
      //       type: key,
      //       url: this.configurationsPayload[this.temp1[index]['value']]['environmentCreationResponse']['infras'][key],
      //       status: true
      //     });
      //   }
      // }
      loaderDialog.close();
      this.platform.openSnackBar('Environment has been successfully setup and email has been sent to: ' + localStorage.getItem('signInEmail') , 'Success', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.router.navigateByUrl('/dev-environments').then(() => {
        window.location.reload();
      });
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error occurred while creating your environment. Please try again later.');
      loaderDialog.close();
    });
  }

  async createEnvironment(event, index) {
    return new Promise(async (resolve, reject) => {
      this.ciSelected = event[this.temp[index]]['settingsPayload']['environments'][0]['cloud'][0]['type'];
      const payload = {
        partner: '',
        account: '',
        configuration: {
          devex: [event[this.temp[index]]['settingsPayload']['environments'][0]['cloud'][0]['type']],
          dashboard: [event[this.temp[index]]['settingsPayload']['environments'][0]['cloud'][0]['type']],
          apigateway: [event[this.temp[index]]['settingsPayload']['environments'][0]['cloud'][0]['type']],
          storage: [event[this.temp[index]]['settingsPayload']['environments'][0]['cloud'][0]['type']]
        }
      };

      if (this.temp[index] === 'prod') {
        payload.partner = this.partner;
        payload.account = this.partner;
      } else {
        payload.partner = this.temp[index] + '-' + this.partner;
        payload.account = this.temp[index] + '-' + this.partner;
      }
      event[this.temp[index]]['envPartner'] = payload['partner'];
      this.configurationsPayload = event;
      await Promise.resolve(this.createInfraWithAccount(event, payload['partner'], this.temp[index], event[this.temp[index]]['partnerPayload'], event[this.temp[index]]['settingsPayload'], payload)).then(async response => {
        this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
            .subscribe(data1 => {
              if (data1 && data1['body'] && data1['body'][0]) {
                this.environmentPayloadInput = data1['body'][0]['environments'];
                this.setUpInitialEnvironmentsToShow();
                resolve('success');
              } else {
                resolve('failed');
              }
            }, error => {
              resolve('success');
            });
        // resolve('success');
      });
    });
  }

  Update() {
    if (this.password.length > 0) {
      if (this.password === this.confirmPassword) {
        const payload = {
          payload: this.temp,
          password: this.password
        };
        this.dataRetrievedToCreateInfra.emit(payload);
      } else {
        alert('Passwords are not matching');
      }
    } else {
      alert('please enter a valid password');
    }
  }

  addEnvironmentsToCreateInfra(value) {
    let isAlreadyPresent = false;
    this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(response => {
      if (response && response['body'] && response['body'][0]) {
        const responseFromApi = response['body'][0];
        for (const env of responseFromApi['environments']) {
          if (value === env['type']) {
            isAlreadyPresent = true;
          }
        }
        if (isAlreadyPresent === false) {
          for (const env of this.temp) {
            if (value === env) {
              isAlreadyPresent = true;
            }
          }
          if (isAlreadyPresent === false) {
            this.environmentPayload[0].custom_environments.push(value.trim());
            this.temp.push(value.trim());
            const temp = {
              environment: value.trim(),
              image: '',
              description: '',
              value: value.trim(),
              isFree: false
            };
            this.temp1.push(temp);
            this.selectedTab = this.temp.length - 1;
            this.customEnvironmentsOnNonSignUp.push(value.trim());
          } else {
            alert('Environment with name ' + value + ' is already been used');
          }
        } else {
          alert('Environment with name ' + value + ' is already present');
        }
      }
    }, error => {
      this.addEnvironmentsToCreateInfra(value);
    });
  }

  async add(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      let capsFound = false;
      let i = 0;
      for (const char of value) {
        const character = value.charAt(i);
        if (!(character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57)) {
          if (char.toUpperCase() === char) {
            capsFound = true;
            break;
          }
        }
        i++;
      }
      if (capsFound === false) {
        if (value.length <= 15) {
          if (!this.isSignUp) {
            this.addEnvironmentsToCreateInfra(value);
          } else {
            this.environmentPayload[0].custom_environments.push(value.trim());
            this.temp.push(value.trim());
            this.selectedTab = this.temp.length - 1;
            this.customEnvironmentsOnNonSignUp.push(value.trim());
            if (this.defaultEnvironmentObject && this.environmentSummary) {
              const tempObject = JSON.parse(JSON.stringify(this.defaultEnvironmentObject));
              tempObject['type'] = value.trim();
              this.environmentSummary.push(tempObject);
            }
          }
        } else {
          this.platform.openSnackBar('Environment name should not exceed 15 characters', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else {
        this.platform.openSnackBar('Environment name should not contain uppercase letters or special characters', 'Error', {
          duration: 7000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(index): void {

    if (this.isSignUp) {
      if (this.defaultEnvironmentObject && this.environmentSummary) {
        for (let j = 0; j < this.environmentSummary.length; j++) {
          if (this.environmentPayload[0].custom_environments[index] === this.environmentSummary[j]['type']) {
            this.environmentSummary.splice(j, 1);
          }
        }
      }
      this.temp.splice(this.temp.indexOf(this.environmentPayload[0].custom_environments[index]), 1);
      this.environmentPayload[0].custom_environments.splice(index, 1);
    }
    if (!this.isSignUp) {
      const key = this.customEnvironmentsOnNonSignUp[index];
      delete this.platform.configurationsForEnvCreation[key];
      this.temp.splice(this.temp.indexOf(this.customEnvironmentsOnNonSignUp[index]), 1);
      const tempArray = [];
      for (const object of this.temp1) {
        if (object['value'] !== key) {
          tempArray.push(object);
        }
      }
      this.temp1 = tempArray;
      this.environmentPayload[0].custom_environments.splice(this.temp.indexOf(this.customEnvironmentsOnNonSignUp[index]), 1);
      this.customEnvironmentsOnNonSignUp.splice(index, 1);
    }
    // this.customEnvironmentsOnNonSignUp.splice(this.customEnvironmentsOnNonSignUp.indexOf(this.environmentPayload[0].custom_environments[index], 1));
  }
}
